// extracted by mini-css-extract-plugin
export default {"tab":"L1LIgu","tab__text":"UXF06b","tab--active":"VCfGoe"};